import { Component, OnInit, PLATFORM_ID, ChangeDetectionStrategy, inject, effect } from '@angular/core';
import { Store } from '@ngrx/store';
import { getSelectedDiseaseProfilePage } from '../../store';
import { isPlatformBrowser } from '@angular/common';

import { getCookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SetTags, SetTitle } from '../../../store';
import { SafePipe, StringUtility } from '@teamfoster/sdk/text-utility';
import { ResizePipe, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { YoutubePlayerComponent } from '@teamfoster/sdk/youtube-player';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-disease-profile-page',
  templateUrl: './disease-profile-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ResizePipe, ResizeHtmlImagesPipe, YoutubePlayerComponent, StripEmbedPipe, SafePipe],
})
export class DiseaseProfilePageComponent implements OnInit {
  #platformId = inject(PLATFORM_ID);
  #store = inject(Store);
  #dict = new FromDictionaryPipe();

  page$ = this.#store.selectSignal(getSelectedDiseaseProfilePage);
  cookiePreferences$ = this.#store.selectSignal(getCookiePreferences);

  pageEffect = effect(() => {
    const page = this.page$();

    if (page) {
      const title = `${page.title} | ${this.#dict.transform('meta-title-suffix')}`;
      this.#store.dispatch(SetTitle({ title }));
      this.#store.dispatch(
        SetTags({
          properties: {
            'description': StringUtility.Truncate(StringUtility.StripHTML(page.text), 157, '...'),
            'og:image': page.imageUrl,
            'og:title': title,
            'og:description': StringUtility.Truncate(StringUtility.StripHTML(page.text), 157, '...'),
          },
        })
      );
    }
  });

  ngOnInit(): void {
    if (isPlatformBrowser(this.#platformId)) {
      window.scrollTo(0, 0);
    }
  }
}
